import { INVENTORY_MODIFIERS_DETAILS } from '../actionTypes';

const initialState = {
  content: [],
  sortModifierGroupList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INVENTORY_MODIFIERS_DETAILS.SUCCESS:
      return {
        ...state,
        ...action.payload,
        sortModifierGroupList: action.payload && action.payload.modifiers ? (action.payload.modifiers).reverse() : [],
      };
    default:
      return state;
  }
};
